export const syntheticDataGenerationPageSeo = {
  title: 'Synthetic Data Generation with Rumble Fish',
  meta: [
    {
      name: 'keywords',
      content:
        'Synthetic data generation, Custom synthetic data solutions, Synthetic data engineering, AI training data generation, Synthetic data development, mostly.ai, tonic data generation',
    },
    {
      name: 'description',
      content: `Custom synthetic data engineering for complex product challenges. We build multi-modal data generation solutions that platforms can't deliver. Battle-tested expertise.`,
    },
  ],
};
